import React from 'react';
import { AwardIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-surface py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-133" data-mp="1j9740qqiilye">
      <div className="mx-auto max-w-3xl px-4" data-id="element-134" data-mp="1n9iq87yiwubz">
        <SectionHeading id="pricing-title" data-id="element-135" data-mp="1ncwq99jpsrg9">Choose Your <span className="text-highlight" data-id="element-136" data-mp="1s8luhq6oiwiw">Option</span></SectionHeading>

        <article className="mt-10 overflow-hidden rounded-3xl border-2 border-cta bg-background shadow-2xl shadow-primary/15" data-id="element-137" data-mp="1x8ztyju7sy5b">
          <div className="border-b border-accent/30 bg-surface/50 px-6 py-4 sm:px-10" data-id="element-138" data-mp="226rug28xdsl4">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary bg-primary/15 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-foreground" data-id="element-139" data-mp="2vh0pm77w1pt">
              <AwardIcon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-140" data-mp="1mh6ld1i2366i" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-141" data-mp="1hp6eep3kjd0f">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-142" data-mp="1ho508br9aaeh">
              <div data-id="element-143" data-mp="1coin02bfgu5o">
                <h3 className="text-2xl font-extrabold uppercase leading-tight tracking-tight text-foreground sm:text-3xl" data-id="element-144" data-mp="17s21zgziyvwt">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-145" data-mp="25f0o4xslclgg">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-146" data-mp="1vgl8bqz0kym9">
                <span className="text-sm text-muted" data-id="element-147" data-mp="1vj7h1txn5k62">
                  Regular price: <span className="line-through decoration-accent decoration-2" data-id="element-148" data-mp="1rf80jbcd2lcp">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-accent" data-id="element-149" data-mp="k03dtwez9629">Today:</p>
                <p className="mt-1 whitespace-nowrap text-5xl sm:text-6xl font-extrabold leading-none tracking-tight text-accent" data-id="element-150" data-mp="g2ywjxvwjfil">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-151" data-mp="mg349co0pg7h">
              Get Chemistry — Teacher Ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-152" data-mp="chdih8t03bly">
              {['Secure payment', 'Instant access', '7-day guarantee'].map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-153" data-mp="3i8psj44echp">
                  <CheckCircle2Icon className="glow-led h-4 w-4 text-highlight" aria-hidden="true" data-id="element-154" data-mp="3kz09je12frga" /> {item}
                </span>)}
            </div>
          </div>
        </article>
      </div>
    </section>;
}